/**
 * Dynamically load Google Maps JavaScript API
 * This ensures the API key is properly injected from environment variables
 */

let googleMapsPromise = null;

export const loadGoogleMapsScript = () => {
    // Return existing promise if already loading/loaded
    if (googleMapsPromise) {
        return googleMapsPromise;
    }

    googleMapsPromise = new Promise((resolve, reject) => {
        // Check if already loaded
        if (window.google && window.google.maps) {
            resolve(window.google.maps);
            return;
        }

        // Get API key from environment
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_WEB_API_KEY;

        if (!apiKey) {
            console.error('❌ No API key in environment variables');
            reject(new Error('Google Maps API key not found in environment variables. Please add REACT_APP_GOOGLE_MAPS_WEB_API_KEY to your .env file.'));
            return;
        }

        // Create script element
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
        script.async = true;
        script.defer = true;

        // Handle load success
        script.onload = () => {
            if (window.google && window.google.maps) {
                resolve(window.google.maps);
            } else {
                reject(new Error('Google Maps failed to load'));
            }
        };

        // Handle load error
        script.onerror = () => {
            reject(new Error('Failed to load Google Maps script'));
        };

        document.head.appendChild(script);
    });

    return googleMapsPromise;
};

// Check if Google Maps is loaded
export const isGoogleMapsLoaded = () => {
    return !!(window.google && window.google.maps);
};
